<template>
    <v-container>
        <h1 class="text-xs-center"><strong>Error 404:</strong> {{ $t('page_not_found')}}</h1><br>
        <v-img
                class="ml-4 mr-4"
                :src="require('../assets/intLogo.png')"
                height="350px"
                contain
        ></v-img>
        <v-card-text class="text-xs-center">
            <h2>{{$t('page_not_found1')}} {{ url }} {{$t('page_not_found2')}}</h2>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn color="primary" @click="$router.go(-1)">{{ $t('atras')}}</v-btn>
            <v-btn color="primary" to="/">{{ $t('inicio')}}</v-btn>
        </v-card-actions>
    </v-container>
</template>

<script>
    export default {
        name: "404",
        data: () => ({
            url: '/'
        }),
        created: function(){
            this.get_url()
        },
        methods:{
            get_url: function () {
                this.url += window.location.pathname.split("/").pop()
            }
        }
    }

</script>
